import { useMemo } from "react";
import { useThemeContext } from "../globalContext/global-context";
import { scopeCustomCss } from "./scopeCustomCss";

export const SurveyCustomCss = () => {
  const { globalObject } = useThemeContext();
  const css = useMemo(
    () => scopeCustomCss(globalObject.themeData.normalizedTheme.custom_css),
    [globalObject.themeData.normalizedTheme.custom_css],
  );
  return css ? <style data-testid="survey-custom-css">{css}</style> : null;
};
